import http from '@/plugins/axios/axios';

export default class PerfilPermissaoService {  

    salvar(requisicao) {       
        return http.post('/api/perfil-permissao/salvar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/perfil-permissao/excluir', requisicao);
    }

    listarMenu(requisicao) {       
        return http.post('/api/perfil-permissao/listar-menu-perfis', requisicao);
    }
}